import React, { Dispatch, FC, SetStateAction } from "react";

import { Chip } from "../forms";
import { TagColors, TagDimensions } from "../forms/elements/tags/types";
import { EMPTY_OPTION_VALUE } from "./constants";
import { WhatsNextFinderFiltersFormTypes } from "./types";

export interface WhatsNextFiltersSummaryProps {
  appliedFilters: WhatsNextFinderFiltersFormTypes;
  setAppliedFilters: Dispatch<SetStateAction<WhatsNextFinderFiltersFormTypes>>;
  labels: {
    "whats-next-finder-panel-clear-filters": string;
  };
}

export const WhatsNextFiltersSummary: FC<WhatsNextFiltersSummaryProps> = ({
  labels,
  appliedFilters,
  setAppliedFilters,
}) => {
  const { search, category } = appliedFilters;

  return (
    <div className="flex items-start justify-between gap-2">
      <div className="flex items-center gap-2 flex-wrap">
        {search && (
          <Chip
            checked
            readOnly
            dimension={TagDimensions.Medium}
            onChange={() => {
              setAppliedFilters((filters) => ({
                ...filters,
                search: EMPTY_OPTION_VALUE,
              }));
            }}
            color={TagColors.Neutral}
            className="max-w-[16ch] truncate"
          >
            {search}
          </Chip>
        )}
        {category && (
          <Chip
            checked
            readOnly
            dimension={TagDimensions.Medium}
            onChange={() => {
              setAppliedFilters((filters) => ({
                ...filters,
                category: EMPTY_OPTION_VALUE,
              }));
            }}
            color={TagColors.Neutral}
            className="max-w-[16ch] truncate"
          >
            {category}
          </Chip>
        )}
      </div>
      <button
        className="font-bold text-primary hover:underline p-2 flex-none"
        type="submit"
        onClick={() => {
          setAppliedFilters((filters) => ({
            ...filters,
            search: EMPTY_OPTION_VALUE,
            category: EMPTY_OPTION_VALUE,
          }));
        }}
      >
        {labels["whats-next-finder-panel-clear-filters"]}
      </button>
    </div>
  );
};
